import { RegisterResponse } from '../../../../../../types/api/endpoints/auth/register.types';
import { AUTH_ENDPOINTS } from '../../../../../../utils/api/endpoints/authEndpoints';
import { RegisterEntityStepFormSchema } from './RegisterEntityStepForm.types';

const PREFIX = '[registerEntityQuery]';

export const REGISTER_SIGN_UP_QUERY_KEY = 'REGISTER_SIGN_UP';

export const registerEntityQuery = async (data: RegisterEntityStepFormSchema) => {
  console.log(PREFIX, `Requesting user account creation...`);
  const response = await AUTH_ENDPOINTS.entity(data);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received user account creation.`);
  return json as RegisterResponse;
};
